import React, { useState, useContext, useEffect, useImperativeHandle, useRef } from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { Link, useLocation, useNavigate } from "react-router-dom";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiSelect from "components/SuiSelect";
import SuiButton from "components/SuiButton";
import Chip from "@mui/material/Chip";
import Card from "@mui/material/Card";
import Avatar from "@mui/material/Avatar";

import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import NumbersIcon from "@mui/icons-material/Numbers";

import toast from "react-hot-toast";

import CategoryContext from "context/category-context";

import api from "services/api";
import moment from "moment";

import { sizeChartOptions, seasonOptions } from "utils/data";
import { DatePicker, Divider } from "antd";
import { promptTags } from "utils/data";
import colors from "assets/theme/base/colors";

let allOptions = [];
promptTags.forEach((x) => allOptions.push(...x.children));

const AddFashionTagModal = React.forwardRef(
  (
    {
      visible,
      handleClose,
      handleOk,
      jobconf = {},
      setJobconf,
      handleRefresh = () => {},
      handleAfterOk = () => {},
      initSelected,
      refreshDelay = 0,
    },
    ref
  ) => {
    const [selectedCat, setSelectedCat] = useState(
      initSelected ? initSelected : promptTags[0]["value"]
    );
    const [newjobconf, setNewjobconf] = useState(jobconf);

    const handleSave = () => {
      setJobconf(newjobconf);
      handleClose();
    };

    const handleTogglePromptArray = (item) => {
      setNewjobconf((prev) => {
        const myArray = prev?.prompt_array || [];
        let prompt_array = [...myArray];
        const findIndex = prompt_array.findIndex((x) => x == item.value);
        if (findIndex > -1) {
          prompt_array.splice(findIndex, 1);
        } else {
          prompt_array.push(item.value);
        }

        return { ...prev, prompt_array };
      });
    };

    const renderTags = (cat) => {
      const findIndex = promptTags.findIndex((s) => s.value == cat);
      if (findIndex > -1) {
        return promptTags[findIndex].children.map((tag) => (
          <Chip
            avatar={tag?.img ? <Avatar src={tag?.img} /> : null}
            label={tag.label}
            variant="outlined"
            size="small"
            color={
              newjobconf?.prompt_array && newjobconf?.prompt_array.includes(tag.value)
                ? "primary"
                : "default"
            }
            onClick={(e) => handleTogglePromptArray(tag)}
            sx={{ mr: 0.5, mb: 0.5 }}
          />
        ));
      }
    };

    const hasTags = newjobconf?.prompt_array && newjobconf.prompt_array.length > 0;

    return (
      <Dialog
        open={visible}
        onClose={(e, reason) => {
          if (reason != "backdropClick") {
            handleClose();
          }
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="md"
        fullWidth={true}
      >
        <DialogTitle id="alert-dialog-title">
          Prompt Tags
          <IconButton
            aria-label="close"
            onClick={() => handleClose()}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Grid container>
            <Grid item xs={12} sm={12} md={hasTags ? 7 : 12} lg={hasTags ? 7 : 12}>
              <SuiBox sx={{ px: 3, py: 1 }}>
                <SuiTypography variant="h6" sx={{ mb: 1 }}>
                  Select the tags you’d like to see in your design
                </SuiTypography>
                <SuiBox display="flex" flexWrap="wrap" gap={1}>
                  {promptTags.map((cat) => (
                    <SuiButton
                      variant={selectedCat == cat.value ? "contained" : "outlined"}
                      size="small"
                      color={selectedCat == cat.value ? "info" : "dark"}
                      sx={{ textTransform: "capitalize", px: 2 }}
                      onClick={() => setSelectedCat(cat.value)}
                    >
                      {cat.label}
                    </SuiButton>
                  ))}
                </SuiBox>
                <Divider />
                <SuiBox display="flex" flexWrap="wrap" gap={0.5}>
                  {renderTags(selectedCat)}
                </SuiBox>
              </SuiBox>
            </Grid>
            {hasTags ? (
              <Grid item xs={12} sm={12} md={5} lg={5}>
                <Card sx={{ px: 2, py: 1, backgroundColor: colors.lightBlue.main }}>
                  <SuiTypography variant="h6" sx={{ mb: 1 }}>
                    Your selected prompt tags...
                  </SuiTypography>
                  <SuiBox display="flex" flexWrap="wrap" gap={1}>
                    {newjobconf.prompt_array.map((pp, index) => {
                      if (pp == "") {
                        return null;
                      }

                      let foundIndex = allOptions.findIndex((x) => x.value == pp);
                      if (foundIndex > -1) {
                        const label =
                          allOptions[foundIndex]?.label || allOptions[foundIndex]?.title;
                        return (
                          <SuiBox>
                            <Chip
                              avatar={
                                allOptions[foundIndex]?.img ? (
                                  <Avatar alt="option_avatar" src={allOptions[foundIndex]?.img} />
                                ) : null
                              }
                              label={label}
                              variant="outlined"
                              sx={{ border: `${colors.dark.main} 1px solid` }}
                              onDelete={() => {
                                const prompt_array = newjobconf?.prompt_array || [];
                                let newPrePrompt = [...prompt_array];
                                newPrePrompt[index] = "";

                                setNewjobconf((prev) => ({
                                  ...prev,
                                  prompt_array: newPrePrompt,
                                }));
                              }}
                            />
                          </SuiBox>
                        );
                      }
                    })}

                    <Chip
                      label="Clear All"
                      onClick={() => {
                        setNewjobconf((prev) => ({
                          ...prev,
                          prompt_array: [],
                        }));
                      }}
                    />
                  </SuiBox>
                </Card>
              </Grid>
            ) : null}
          </Grid>
        </DialogContent>
        <DialogActions>
          <SuiButton variant="gradient" size="medium" onClick={handleClose} color="light">
            Cancel
          </SuiButton>
          <SuiButton size="medium" variant="gradient" color="dark" onClick={handleSave}>
            Save
          </SuiButton>
        </DialogActions>
      </Dialog>
    );
  }
);

export default AddFashionTagModal;
